import { createContext } from 'react';
import { SupportModalToggleContextType } from '#baseSupportModal/contexts';

const SupportModalToggleContext = createContext<SupportModalToggleContextType>(null);

export { SupportModalToggleContext };
